import React, { useEffect, useState, useRef, useMemo, useContext } from 'react'
import styles from "./index.module.scss"
import  * as echarts from 'echarts'
import lottie from 'lottie-web'
import MessageBox from "@/components/message-box"
// import NavBar from '@/components/nav-bar'
import LoadingPage from '@/components/loading-page'
// import LoadingCenter from '@/components/loading-center'
import {
  ErrorPlaceholder,
  EmptyPlaceholder,
} from "@/components/placeholder"
import {
  setFullScreen,
  formatTimestampToTxt,
  // jumpPage
} from '@/utils/common'
import { getChargingRecordLatest } from '@/api/charging-real-time-curve'
import useQuery from "@/hooks/useQuery"
import request from '@/network/request'
import JSBridge from '@xpeng/js-bridge'
import './reset.scss'
import { ThemeModeContext } from "../../../ThemeModeContext"
import './_variables.css'

const DEFAULT_ERROR_MSG = '服务器开小差啦'
const LOOP_TIME = 10 * 1000

const App = () => {
  // 颜色主题
  const themeModeContext = useContext(ThemeModeContext)
  const themeMode = themeModeContext?.mode || 'light'
  
  
  const queryVin = useQuery().get('vin') || ''

  const lottieNode = useRef<any>(null)

  // 监听当前页面是否可见
  const pageVisible = useRef(true)

  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingError, setIsLoadingError] = useState(false)
  const [isEmptyPage, setIsEmptyPage] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  // const [isLoadingCenter, setIsLoadingCenter] = useState(false)

  // const [title, setTitle] = useState('充电进行中') // 页面标题
  // const [remainTime, setRemainTime] = useState<any>('') // 预计剩余时间

  const isChargingFlag = useRef(false) // 是否正在充电flag
  const [isCharging, setIsCharging] = useState(false)
  const [chargingData, setChargingData] = useState<{ startStatus: any, currentStatus: any }>({
    startStatus: {},
    currentStatus: {}
  })
  const { currentStatus, startStatus } = chargingData
  const [currentData, setCurrentData] = useState({
    power: 0,
    voltage: 0,
    ec: 0
  })
  
  const [chargeTime, setChargeTime] = useState<any>({ h: 0, m: 0 }) // 充电时长
  const [startTime, setStartTime] = useState('') // 充电开始时间
  const [endTime, setEndTime] = useState('') // 充电结束时间
  // const [batteryImgNum, setBatteryImgNum] = useState(0) // 电池图片编号
  const [increaseKm, setIncreaseKm] = useState(0) // 增加里程
  // const [hasChargingOrder, setHasChargingOrder] = useState(true) // 是否有进行中的充电订单
  const chargingOrderNo = useRef('') // 进行中充电订单号
  const [fastChargeAddMileage, setFastChargeAddMileage] = useState(0) // 极速充电增加里程

  // echarts
  const myChart = useRef<any>(null)
  const lineChartRef = useRef<any>(null)
  const [currentLineType, setCurrentLineType] = useState<'power' | 'voltage' | 'ec'>('power')
  const [xLabels, setXLabels] = useState<any[]>([])
  const [powerLineData, setPowerLineData] = useState<any[]>([])
  const [voltageLineData, setVoltageLineData] = useState<any[]>([])
  const [ecLineData, setEcLineData] = useState<any[]>([])
  const lineLoopTimer = useRef<any>(null)
  const [markLine, setMarkLine] = useState<any>(null)
  // const batteryMonitorStatus = useRef<any>(null)

  const lineInfo = {
    'power': {
      title: '实时输入功率',
      unit: 'kW',
    },
    'voltage': {
      title: '实时电压',
      unit: 'V'
    },
    'ec': {
      title: '实时电流',
      unit: 'A'
    }
  }

  // 折线图Option
  const lineChartOption = useMemo(() => {
    const formatPowerYMaxValue = (value: any) => {
      const max = value.max
      if (max >= 0 && max <= 20) {
        return 25
      } else if (max > 20 && max < 50) {
        return 60
      } else if (max >= 50 && max < 100) {
        return 120
      } else if (max >= 100 && max < 200) {
        return 240
      } else if (max >= 200 && max <= 299) {
        return 400
      } else if (max >= 300 && max <= 550) {
        return 600
      }
    }
    
    const formatVoltageYMaxValue = (value: any) => {
      const max = value.max
      if (max >= 220 && max <= 380) {
        return 450
      } else if (max >= 381 && max <= 450) {
        return 600
      } else if (max >= 451 && max <= 600) {
        return 700
      } else if (max >= 601 && max <= 799) {
        return 800
      } else {
        return max
      }
    }
  
    const formatEcYMaxValue = (value: any) => {
      const max = value.max
      if (max >= 0 && max <= 39) {
        return 40
      } else if (max >= 40 && max <= 149) {
        return 200
      } else if (max >= 150 && max <= 249) {
        return 300
      } else if (max >= 250 && max <= 349) {
        return 400
      } else if (max >= 350 && max <= 449) {
        return 500
      } else if (max >= 450 && max <= 549) {
        return 600
      } else {
        return max
      }
    }

    // const formatXInterval = () => {
    //   const startSoc = startStatus?.soc
    //   if (startSoc >= 0 && startSoc <= 19) {
    //     return 19
    //   } else if (startSoc >= 20 && startSoc <= 59) {
    //     return 9
    //   } else if (startSoc >= 60 && startSoc <= 91) {
    //     return 4
    //   } else {
    //     return 0
    //   }
    // }
    const LINE_DATA_MAP = {
      'power': powerLineData,
      'voltage': voltageLineData,
      'ec': ecLineData
    }

    const Y_MAX_VALUE_FORMATTER = {
      'power': formatPowerYMaxValue,
      'voltage': formatVoltageYMaxValue,
      'ec': formatEcYMaxValue
    }
    const lineData = LINE_DATA_MAP[currentLineType]
    const formatYMaxValue = Y_MAX_VALUE_FORMATTER[currentLineType]
    const defaultColorMap = {
      xLabelsColor: 'rgba(0, 0, 0, 0.4)',
      xLineColor: '#E5E5E5',
      ySplitLineColor: '#CCCCCC',
      yLabelsColor: 'rgba(0, 0, 0, 0.4)',
      lineColor: '#54B685',
      pointItemColor: '#FFFFFF',
      pointItemBorderColor: '#54B685'
    }
    const darkColorMap = {
      xLabelsColor: 'rgba(255, 255, 255, 0.4)',
      xLineColor: '#717173',
      ySplitLineColor: '#414245',
      yLabelsColor: 'rgba(255, 255, 255, 0.4)',
      lineColor: '#54B685',
      pointItemColor: '#121316',
      pointItemBorderColor: '#54B685'
    }
    const colorMap = themeMode === 'dark' ? darkColorMap : defaultColorMap
    return {
      grid: {
        top:'3%',
        left: 0,
        right:'3%',
        bottom: 0,
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisTick: { show: false },
        axisLabel: {
          // color: '#B3B3B3',
          color: colorMap.xLabelsColor,
          fontSize: '10px',
          margin: 15,
          // interval: formatXInterval()
          interval: 9
        },
        axisLine: {
          lineStyle: {
            // color: 'rgba(0, 0, 0, 0.1)'
            // color: '#E5E5E5'
            color: colorMap.xLineColor
          }
        },
        data: xLabels
      },
      yAxis: {
        type: 'value',
        max: formatYMaxValue,
        splitLine: {
          show: true,
          lineStyle: {
            // color: 'rgba(0, 0, 0, 0.2)',
            color: colorMap.ySplitLineColor,
            type: 'dashed',
            width: 0.5
          }
        },
        axisLabel: {
          // color: '#B3B3B3',
          color: colorMap.yLabelsColor,
          fontSize: '10px',
          // formatter: function (value, index) {
          //   return value.toFixed(1)
          // }
        }
      },
      // color: ['#8CB654'],
      color: [colorMap.lineColor],
      series: [{
        smooth: true,
        symbol: 'none',
        name: '',
        type: 'line',
        data: lineData,
        markPoint: {
          symbol: 'circle',
          data:[
            {
              type: 'max',
              name: '最大值',
              symbolSize : 5,
              value: '',
              itemStyle: {
                color: colorMap.pointItemColor,
                borderColor: colorMap.pointItemBorderColor,
              },
              label: {
                show: true,
                formatter: ''
              }
            }
          ]
        },
        markLine: markLine,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0, color: 'rgba(84, 182, 133, 0.3)'
          }, {
            offset: 1, color: 'rgba(84, 182, 133, 0)'
          }])
        }
      }]
    }
  // }, [currentLineType, powerLineData, voltageLineData, ecLineData, xLabels, startStatus])
  }, [currentLineType, powerLineData, voltageLineData, ecLineData, xLabels, markLine, themeMode])

  useEffect(() => {
    // document.title = '充电数据'
    setFullScreen()
    pageVisibleListener()

    getChargingData()
    // getChargingOrderData()
    listenRefershData()
    return componentWillUnmount
  }, [])

  // 这里处理echarts的实时渲染逻辑
  useEffect(() => {
    if (lineChartRef.current) {
      const chart = echarts.getInstanceByDom(lineChartRef.current)
      if (chart) {
        myChart.current = chart
      } else {
        myChart.current = echarts.init(lineChartRef.current)
      }
      if (!myChart.current.getOption()) {
        // 首次渲染完整option
        myChart.current.setOption(lineChartOption)
        // console.log('firstSetOption -->', myChart.current.getOption())
      } else {
        // 后续仅更新x、y轴和series
        myChart.current.setOption({
          xAxis: lineChartOption.xAxis,
          yAxis: lineChartOption.yAxis,
          series: lineChartOption.series
        })
        // console.log('nextSetOption -->', myChart.current.getOption())
      }
    }
  }, [lineChartOption, isLoading])

  // 适配折叠屏
  useEffect(() => {
    const handleResize = () => {
      if (!lineChartRef.current) return
      const chart = echarts.getInstanceByDom(lineChartRef.current)
      chart?.resize({
        animation: { duration: 300 } // 可选动画效果
      })
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const componentWillUnmount = () => {
    myChart.current && myChart.current.dispose()
    lottie.destroy('loading-battery')
    stopLoopLineData()
  }

  // 用户可能跳转到充电RN去支付充电订单，返回到H5的时候需要重新拉取充电订单数据，没有进行中订单时应关闭tips
  const pageVisibleListener = () => {
    document.addEventListener('visibilitychange', () => {
      console.log('document.visibilityState -->', document.visibilityState)
      if (document.visibilityState === 'hidden') {
        pageVisible.current = false
      }
      if (!pageVisible.current && document.visibilityState === 'visible') {
        getChargingOrderData()
      }
    })
  }

  const showLottie = () => {
    lottie.destroy('loading-battery')
    import('../assets/loading.json').then((animationData) => {
      if (lottieNode.current) {
        lottie.loadAnimation({
          name: 'loading-battery',
          container: lottieNode.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
        });
      }
    })
  }

  const formatXLabels = (startX: number, closeToTen: number) => {
    const xLabels: number[] = []
    if (startX >= 0 && closeToTen >= 0) {
      for (let i = closeToTen; i <= 100; i++) {
        xLabels.push(i)
      }
      return xLabels
    } else {
      return [0, 100]
    }
  }

  const formatYData = (data: number[], needToFill) => {
    if (!isValidArray(data)) return []
    const fillArr = new Array(needToFill).fill('')
    const powerData = fillArr.concat(data)
    // 如果这个点超过100个 后面的点就不要了
    powerData.length > 100 && powerData.splice(100)
    return powerData
  }

  // const changeLineType = (type: "power" | "voltage" | "ec") => {
  //   setCurrentLineType(type)
  // }

  /**
   * 获取当前充电数据
   * 产品要求每10s刷新一次数据，但是后台接口数据落盘会有延时，可能存在请求接口以后数据没有更新的场景
   * 这里同时请求app的mqtt实时数据，是否充电中、剩余充电时间、当前soc、当前电压、当前电流、当前功率这几个字段取实时数据展示，其他的数据取后台接口
   * 是否充电中以app返回为准，app返回充电完成后，所有数据为初始值不可用，这时全部取后台接口数据
   * @param firstLoad 
   */
  const getChargingData = async (firstLoad = true) => {
    try {
      const res: any = await getChargingRecordLatest({ vin: queryVin })
      const bridgeRes: any = await getChargingDataFromMqtt()
      if (bridgeRes.code === 1 && res.code === 200) {
        const data = res?.data
        const bridgeData = bridgeRes?.data
        if (!!bridgeData) {
          isChargingFlag.current = Boolean(bridgeData?.isCharging)
          // batteryMonitorStatus.current = bridgeData?.currentStatus?.batteryMonitorStatus
          setIsCharging(isChargingFlag.current)
          formatData(data, bridgeData)
          if (isChargingFlag.current) {
            // setTitle('充电进行中')
            loopLineData()
            firstLoad && showLottie()
            // 曲线信息拉取成功后，再拉取充电订单数据 仅首次拉取
            firstLoad && getChargingOrderData(firstLoad)
          } else {
            // setTitle('充电完成')
            stopLoopLineData()
            lottie.stop('loading-battery')
            // 当轮询到充电结束时，重新请求充电订单数据
            // if (!firstLoad) {
            //   getChargingOrderData()
            // }
            // 首次进入页面要拉充电信息， 非首次进入但是轮询到充电结束时也要拉充电信息
            getChargingOrderData(firstLoad)
          }
        }
      } else {
        if (firstLoad) {
          setIsEmptyPage(true)
          setErrorMsg(DEFAULT_ERROR_MSG)
        }
      }
    } catch (error) {
      console.log('getChargingData error -->', error)
      if (firstLoad) {
        setIsLoadingError(true)
        setErrorMsg(DEFAULT_ERROR_MSG)
      }
    } finally {
      setIsLoading(false)
      // setIsLoadingCenter(false)
    }
  }

  const getChargingDataFromMqtt = () => {
    return new Promise<any>((resolve, reject) => {
      JSBridge.callHandler('carControlChargeState', {})
        .then(res => {
          resolve(res)
        }).catch(err => {
          MessageBox.toast(DEFAULT_ERROR_MSG)
          console.log('carControlChargeState err -->', err)
          reject(err)
        })
    })
  }

  const loopLineData = () => {
    if (!lineLoopTimer.current) {
      lineLoopTimer.current = setInterval(() => {
        getChargingData(false)
      }, LOOP_TIME)
    }
  }

  const stopLoopLineData = () => {
    clearInterval(lineLoopTimer.current)
    lineLoopTimer.current = null
  }

  /**
   * 充电进行中需要合并bridge的数据，充电完成后只取后台接口数据
   * @param data 
   * @param bridgeData 
   */
  const formatData = (data: any, bridgeData: any) => {
    if (!data || !bridgeData) return
    if (isChargingFlag.current) {
      /* 充电进行中 */
      const mergeChargingData = {
        startStatus: data?.startStatus,
        currentStatus: {
          soc: bridgeData?.currentStatus?.soc,
          voltage: bridgeData?.currentStatus?.voltage,
          current: bridgeData?.currentStatus?.current,
          power: bridgeData?.currentStatus?.power,
          availableRemainingDistance: bridgeData?.currentStatus?.availableRemainingDistance,
        }
      }
      setChargingData(mergeChargingData)
      const { currentStatus } = mergeChargingData
      // setBatteryImgNum(currentStatus?.soc > 100 ? 50 : Math.ceil(currentStatus?.soc / 2)) // 电池图片进度
      // setRemainTime(bridgeData?.timeToCompleteCharge ? toHourMinute(bridgeData?.timeToCompleteCharge) : '计算中') // 预计剩余时间

      // p7可能不会返回功率 所以在这里判断一下 如果没有就取电压和电流相乘
      let power = 0
      if (currentStatus?.power === 0) {
        if (currentStatus?.voltage > 0 && currentStatus?.current > 0) {
          power = (currentStatus?.voltage) * (currentStatus?.current) / 1000
        } else {
          power = 0
        }
      } else {
        power = currentStatus?.power
      }
      // 实时功率、电压、电流
      setCurrentData({
        // power: currentStatus.power,
        power,
        voltage: currentStatus.voltage,
        ec: currentStatus.current
      })
    } else {
      /* 充电结束 */
      setChargingData(data)
      const { startStatus, currentStatus } = data
      // setBatteryImgNum(currentStatus?.soc > 100 ? 50 : Math.ceil(currentStatus?.soc / 2)) // 电池图片进度

      // 实时功率、电压、电流
      setCurrentData({
        power: currentStatus.power,
        voltage: currentStatus.voltage,
        ec: currentStatus.current
      })

      /* 充电结束状态卡片数据 */
      if (startStatus.ts && currentStatus.ts) {
        const gapTs = currentStatus.ts - startStatus.ts
        const gapMins = Math.ceil(gapTs / 1000 / 60)
        setChargeTime(toHourMinute(gapMins, true))
        setStartTime(formatTimestampToTxt(startStatus.ts, 'HH:mm'))
        setEndTime(formatTimestampToTxt(currentStatus.ts, 'HH:mm'))
      }
      const startMileage = startStatus?.availableRemainingDistance
      const endMileage = currentStatus?.availableRemainingDistance
      if (startMileage && endMileage) {
        const increaseKm = Math.floor(endMileage) - Math.floor(startMileage)
        setIncreaseKm(Math.floor(increaseKm) || 0)
      }
      // 极速充电增加里程 充电结束时展示
      if (bridgeData?.currentStatus?.fastChargeAddMileage > 0) {
        let fastChargeAddMileage = Math.trunc(bridgeData?.currentStatus?.fastChargeAddMileage)
        setFastChargeAddMileage(fastChargeAddMileage)
      }
    }

    // 折线图数据
    // const startSoc = data?.startStatus?.soc
    // const labels = formatXLabels(startSoc)
    // setXLabels(labels)
    // const { current, voltage, power } = data?.chargeProcess
    // isValidArray(power) && setPowerLineData(power)
    // isValidArray(voltage) && setVoltageLineData(voltage)
    // isValidArray(current) && setEcLineData(current)
    const startSoc = data?.startStatus?.soc
    const { current, voltage, power } = data?.chargeProcess
    formatLineData(startSoc, power, voltage, current)
  }

  const formatLineData = (startSoc, power, voltage, current) => {
    // 新需求需要x轴初始位置从soc开始向前取10的整数倍
    const closeToTen = Math.floor(startSoc / 10) * 10
    const labels = formatXLabels(startSoc, closeToTen)
    setXLabels(labels)
    // x轴向前了 Y轴需要补充空值
    const needToFillEmpty = Math.trunc(startSoc - closeToTen)
    if (needToFillEmpty >= 0) {
      let powerData = formatYData(power, needToFillEmpty)
      setPowerLineData(powerData)
      // 找到最大值的点
      const maxPower = Math.max(...powerData)
      const index = powerData.indexOf(maxPower)
      const markLine = formatMarkLine(maxPower, labels, index)
      setMarkLine(markLine)
      isValidArray(voltage) && setVoltageLineData(formatYData(voltage, needToFillEmpty))
      isValidArray(current) && setEcLineData(formatYData(current, needToFillEmpty))
    }
  }

  const formatMarkLine = (maxPower, xLabels, index) => {
    if (!isValidArray(xLabels) || !maxPower || index < 0) return null
    // let yOffset
    let yLabelMax
    if (maxPower >= 0 && maxPower <= 20) {
      yLabelMax = 25
    } else if (maxPower > 20 && maxPower < 50) {
      yLabelMax = 60
    } else if (maxPower >= 50 && maxPower < 100) {
      yLabelMax = 120
    } else if (maxPower >= 100 && maxPower < 200) {
      yLabelMax = 240
    } else if (maxPower >= 200 && maxPower <= 299) {
      yLabelMax = 400
    } else if (maxPower >= 300 && maxPower <= 550) {
      yLabelMax = 600
    }
    const yOffset = Math.trunc(yLabelMax / 9)
    // 判断是否超过一半
    const isOverHalf = index > Math.trunc(xLabels.length / 2)
    let xOffset = Math.trunc(xLabels.length / 10)
    let xOffsetOne = isOverHalf ? - xOffset : xOffset
    // 一半的偏移量 为0时默认为1
    const halfXOffset = Math.trunc(xOffset / 2) || 1
    let xOffsetTwo = isOverHalf ? - halfXOffset : halfXOffset
    const maxPonitXlabel = xLabels[index]
    const x1 = maxPonitXlabel
    const y1 = maxPower
    const x2 = maxPonitXlabel + xOffsetOne
    const y2 = maxPower + yOffset
    const x3 = x2 + xOffsetTwo
    const showMaxPower = maxPower.toFixed(1)
    const defaultColorMap = {
      color: '#54B685',
      backgroundColor: 'rgba(67, 184, 126, 0.1)',
    }
    const darkColorMap = {
      color: '#54B685',
      backgroundColor: 'rgba(67, 184, 126, 0.1)'
    }
    const colorMap = themeMode === 'dark' ? darkColorMap : defaultColorMap
    return {
        symbol: 'none',
        silent: true,
        data: [
          [ { coord: [`${x1}`, `${y1}`]}, { coord: [`${x2}`, `${y2}`] }],
          [ { coord: [`${x2}`, `${y2}`]},
            {coord: [`${x3}`, `${y2}`],
              label: {
                show: true,
                formatter: `MAX: ${showMaxPower}kW`,
                color: colorMap.color,
                backgroundColor: colorMap.backgroundColor,
                padding: [4, 8],
              }
            }
          ]
        ]
      }
  }

  /**
   * 获取进行中的充电订单，先查使用中'04'，若没有再查待支付'05'，若都没有则没有充电订单
   */
  const getChargingOrderData = async (firstLoad = false) => {
    try {
      let usingOrderInfo: any
      let toPayOrderInfo: any
      usingOrderInfo = await getChargingOrder('04')
      if (!!usingOrderInfo) {
        // setHasChargingOrder(true)
        chargingOrderNo.current = usingOrderInfo?.orderNo
        console.log('usingOrderInfo -->', usingOrderInfo)
      } else {
        toPayOrderInfo = await getChargingOrder('05')
        if (!!toPayOrderInfo) {
          // setHasChargingOrder(true)
          chargingOrderNo.current = toPayOrderInfo?.orderNo
          console.log('toPayOrderInfo -->', toPayOrderInfo)
        }
      }
      const orderId = usingOrderInfo?.orderNo || toPayOrderInfo?.orderNo
      if (firstLoad) {
        // 首次加载完成或订单变化时通知app
        notifyAppOrderChange({ isFirst: firstLoad, orderId })
      } else {
        orderId && notifyAppOrderChange({ isFirst: firstLoad, orderId })
      }

      // 若使用中和待支付订单都没有，则关闭充电订单tips
      // if (!usingOrderInfo && !toPayOrderInfo) {
      //   setHasChargingOrder(false)
      // }
    } catch (error) {
      console.log('getChargingOrderData error -->', error)
    }
  }

  const getChargingOrder = (orderStatus: string) => {
    return new Promise<any>((resolve, reject) => {
      request('/biz/v5/charge/carControl/getOrderByOrderStatus', { orderStatus })
      .then((data: any) => {
        if (data?.list?.length > 0) {
          resolve(data?.list[0])
        } else {
          resolve(null)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  const isValidArray = (arr: any[]) => {
    return Array.isArray(arr) && arr.length > 0
  }

  const toHourMinute = (min: any, onlyNumber = false) => {
    if (['', undefined, null].includes(min)) return '-'
    if (onlyNumber)  {
      return {
        h: Math.floor(min / 60),
        m: min % 60
      }
    }

    if (min <= 5) {
      return '即将完成'
    } else if (min > 5 && min < 60) {
      return `${min}分钟`
    } else if (min >= 60) {
      if (min % 60 === 0) {
        return `${Math.floor(min / 60)}小时`
      } else {
        return `${Math.floor(min / 60)}时${min % 60}分`
      }
    } else return '-'
  }
  // 结束充电和订单tips原生做，这里不再处理
  // const finishCharging = () => {
  //   if (isLoadingCenter) return
  //   let childrenText = batteryMonitorStatus.current === 1 ? '车辆已较长时间或行驶较长里程未充满电，可能导致续航估算不准建议等待电池充满' : ''
  //   MessageBox.confirm({
  //     title: '确定结束充电？',
  //     children: <div style={{textAlign: 'center'}}>{childrenText}</div>,
  //     className: batteryMonitorStatus.current === 1 ? '': 'finish-charging-message-box',
  //     cancelButtonText: '取消',
  //     confirmButtonText: '确认'
  //   }).then(() => {
  //     JSBridge.callHandler('carControlStopCharging', {})
  //       .then(res => {
  //         console.log('carControlStopCharging res -->', res)
  //         if (res.code === 1) {
  //           // 结束充电成功，重新请求充电数据
  //           setIsLoadingCenter(true)
  //           getChargingData(false)
  //         } else {
  //           // app会toast错误信息，这里不再toast
  //         }
  //       }).catch(err => {
  //         MessageBox.toast(DEFAULT_ERROR_MSG)
  //         console.log('carControlStopCharging err -->', err)
  //       })
  //   }).catch(() => {
  //     // cancel
  //   })
  // }

  // const goToOrderPage = () => {
  //   jumpPage(`xiaopeng://charging/manage?orderNo=${chargingOrderNo.current}`)
  // }

  // const TipsBar = ({ show, msg, btnText, onClick = () => {} } : { show: boolean, msg: string, btnText: string, onClick: () => void}) => {
  //   return (
  //     <div className={`${styles.tipsBar} ${!isCharging ? styles.bt50 : ''} ${show ? styles.show : ''}`} onClick={onClick}>
  //       <div className={styles.tipsMsg}>{msg}</div>
  //       <div className={styles.tipsBtn}>{btnText}</div>
  //     </div>
  //   )
  // }

  // 1、改版曲线数据首次加载完成/订单数据变化要通知app
  interface NotifyAppOrderChangeData {
    isFirst: boolean,  // 是否首次加载
    orderId: string  // 订单号
  } 
  const notifyAppOrderChange = (data: NotifyAppOrderChangeData) => {
    JSBridge.callHandler('onReloadData', data)
      .then(res => {
        console.log('notifyAppOrderChange res -->', res)
      }).catch(err => {
        MessageBox.toast(DEFAULT_ERROR_MSG)
        console.log('notifyAppOrderChange err -->', err)
      })
  }
  // 2、app 调用 onRefresh 方法，需要H5重新刷新ui
  const listenRefershData = () => {
    JSBridge.registerHandler('onRefresh', function(data, responseCallback) {
      console.log('onRefresh data -->', data)
      getChargingData(false)
    })
  }

  if (isLoading) {
    return (
      <LoadingPage />
    )
  }

  if (isLoadingError)
    return (
      <ErrorPlaceholder
        message={errorMsg}
      ></ErrorPlaceholder>
    )

  if (isEmptyPage)
    return (
      <EmptyPlaceholder text={errorMsg}></EmptyPlaceholder>
    )

  return (
    <div className={`${styles.homePage} ${isCharging ? '' : styles.noCharging}`}>
      {/* <NavBar title={title} /> */}
      <div className={styles.scrollView}>
        {/* <div className={styles.gradientBg}>
          <img className={styles.carImg} alt='' src={require('../assets/car_new.png')} />
          <div className={styles.batteryImg} ref={item => { lottieNode.current = item }}>
            <img alt='' src={require(`../assets/charging/${batteryImgNum}@2x.png`)}/>
          </div>
          <div className={`${styles.socAndMileage} ${isCharging ? '' : styles.noCharging}`}>
            {
              currentStatus?.availableRemainingDistance ? <>
                <div className={styles.dataItem}>
                  <span className={styles.number}>{Math.floor(currentStatus.availableRemainingDistance)}</span>
                  <span className={styles.unit}>km</span>
                </div>
                <div className={styles.devideLine}></div>
              </> : null
            }
            <div className={styles.dataItem}>
            <span className={styles.number}>{currentStatus?.soc || '-'}</span>
            <span className={styles.unit}>%</span>
            </div>
          </div>
          { (isCharging && !!remainTime) ? <div className={styles.remainTime}>预计剩余时间 <span className={styles.timeText}>{remainTime}</span></div> : null }
        </div> */}
        {
          <div className={`${styles.socCard} ${!isCharging ? styles.noCharging : ''}`}>
            <div className={styles.title}>充电用时</div>
            <div className={styles.time}>
              {!!chargeTime.h && `${chargeTime.h}`}{!!chargeTime.h && <span className={styles.unit}>时</span>}
              {chargeTime.m}<span className={styles.unit}>分</span>
            </div>
            <div className={styles.socChangeRow}>
              <div className={styles.startSocInfo}>
                <div className={styles.startSoc}>{startStatus?.soc || '-'}%</div>
                <div className={styles.startTime}>
                  <span className={styles.label}>起</span>
                  <span className={styles.value}>{startTime}</span>
                </div>
              </div>
              <div className={styles.changeSocInfo}>
                <hr className={styles.dashedLine}></hr>
                <div className={styles.changeSocWrap}>
                  <div className={styles.increaseKm}>+{increaseKm}km</div>
                  <div className={styles.label}>增加里程</div>
                </div>
                <hr className={styles.dashedLine}></hr>
              </div>
              <div className={styles.endSocInfo}>
                <div className={styles.endSoc}>{currentStatus?.soc || '-'}%</div>
                <div className={styles.endTime}>
                  <span className={styles.label}>止</span>
                  <span className={styles.value}>{endTime}</span>
                </div>
              </div>
            </div>
            { (!isCharging && fastChargeAddMileage > 0 ) ? <>
              <div className={styles.fastChargeAddMileage}>
                <div>极速充电，比普通快充多增加约
                  <span className={styles.mileageNumber}>{fastChargeAddMileage}km</span>
                </div>
              </div>
            </>: null
            }
          </div>
        }
        <div className={`${styles.curveContainer} ${!isCharging ? styles.noCharging : ''}`}>
          {/* <div className={styles.tabsBar}>
            <span className={`${styles.tab} ${ currentLineType === 'power' ? styles.active : ''}`} onClick={() => changeLineType('power')}>功率</span>
            <span className={`${styles.tab} ${ currentLineType === 'voltage' ? styles.active : ''}`} onClick={() => changeLineType('voltage')}>电压</span>
            <span className={`${styles.tab} ${ currentLineType === 'ec' ? styles.active : ''}`} onClick={() => changeLineType('ec')}>电流</span>
          </div> */}
          <div className={styles.realTimeData}>
            <div className={styles.title}>
              {isCharging ? lineInfo[currentLineType]?.title : '充电曲线'}
            </div>
            {
              isCharging && (
                <div className={styles.data}>
                  {currentData[currentLineType].toFixed(1)}&nbsp;
                  <span className={styles.unit}>{lineInfo[currentLineType]?.unit}</span>
                </div>
              )
            }
          </div>
          <div className={`${styles.dataDesc} ${isCharging ? '' : 'noCharging'}`}>
            <span className={styles.lineChartUnit}>单位：{lineInfo[currentLineType]?.unit}</span>
            {
              isCharging && (
                <span className={styles.currentAndVol}>
                  <span className={styles.current}>电流：{currentData.ec.toFixed(1)}A</span>
                  <span className={styles.voltage}>电压：{currentData.voltage.toFixed(1)}V</span>
                </span>
              )
            }
          </div>
          <div className={styles.chartContainer} ref={lineChartRef}></div>
          <div className={styles.lineChartXDesc}>{'电量(%)'}</div>
        </div>
      </div>
      {/* {
        // 新的方案，原生里面内嵌H5 结束充电的按钮原生去做
        isCharging && (
          <div className={styles.bottomContainer}>
            <div className={styles.bottomBtn} onClick={finishCharging}>结束充电</div>
          </div>
        )
      } */}
      {/* <TipsBar show={hasChargingOrder} msg='你有充电订单进行中' btnText='立即查看' onClick={goToOrderPage}/> */}
      {/* { isLoadingCenter && <LoadingCenter msg='结束充电中' /> } */}
    </div>
  )
}

export default App